import { TileImage, pxToRem } from '@archipro-design/aria';
import { getImagesSizes } from '~/utils/image-sizes-utils';
import { useRef } from 'react';
import type { AdvertData } from '@archipro-website/tracker';
import { useAdEventHandler, useTracker } from '@archipro-website/tracker';
import { createLinkedComponentParams } from '~/utils/urlHelper';

interface AdvertMediumRectangleProps {
    title: string;
    carousel: {
        href: string;
        imageMobile: string;
    }[];
    advertCreative: AdvertData;
}

const ADVERT_MEDIUM_RECTANGLE_SIZE = {
    width: 300,
    height: 250,
};

const AdvertMediumRectangle = ({
    title,
    carousel,
    advertCreative,
}: AdvertMediumRectangleProps) => {
    const ref = useRef(null);
    const { onClick: onAdClick } = useAdEventHandler(advertCreative, ref);
    const tracker = useTracker();

    return (
        <TileImage
            ref={ref}
            height={pxToRem(ADVERT_MEDIUM_RECTANGLE_SIZE.height)}
            width={pxToRem(ADVERT_MEDIUM_RECTANGLE_SIZE.width)}
            images={carousel.map((carousel) => {
                const { imageMobile, href } = carousel;

                return {
                    alt: title || '',
                    src: imageMobile,
                    width: ADVERT_MEDIUM_RECTANGLE_SIZE.width,
                    height: ADVERT_MEDIUM_RECTANGLE_SIZE.height,
                    sizes: getImagesSizes(ADVERT_MEDIUM_RECTANGLE_SIZE.width),
                    overlay: {
                        children: <div />,
                        ...createLinkedComponentParams(
                            tracker,
                            'Ad_ImageClick',
                            href,
                            {
                                libraryItemID: advertCreative.professional.id,
                                professionalID: advertCreative.professional.id,
                            },
                            null,
                            onAdClick,
                        ),
                        prefetch: 'intent',
                        icon: <div />,
                        alwaysVisible: true,
                        variables: {
                            backgroundColor: 'transparent',
                        },
                    },
                };
            })}
            hideFavourite={true}
            style={{ margin: 'auto' }}
        />
    );
};

export default AdvertMediumRectangle;
